<template>
    <div class="content_list_page">
        <div v-wechat-title="$route.meta.title"></div>
        <div class="column_list">
            <div class="column_cont" v-for="item in columnList" :key="item.id" @click="outbreaklist(item)">
                <img :src="item.coverImage" alt="">
                <!-- <el-image :src="item.srcUrl" lazy></el-image> -->
                <p>{{ item.name }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { columnList, getColumnByParentId, generateSign } from '@/api/index'
import Bus from '@/Bus'


const columnParameter = {
    appInfoId: "10",
    parentId: ""
}
export default {
    data() {
        return {
            jumpRouting: true,
            columnDefine: Object.assign({}, columnParameter),
            columnList: [
                // {
                //     id:'b2f48823-a449-48e7-91ec-77d88924b0b3',
                //     name:'全国两会',
                //     srcUrl:require('./img/qglh.png'),
                // },{
                //     id:'5e3d40cfe4b0a6957ef82267',
                //     name:'抗击疫情',
                //     srcUrl:require('./img/kjyq.jpg'),
                // },
                // {
                //     id:'5e804a48e4b027314a1354e9',
                //     name:'教育事业',
                //     srcUrl:require('./img/jysy.jpg')
                // },
                // {
                //     id:'14f8ad46-c35c-414c-827f-deff96f54900',
                //     name:'党的建设',
                //     srcUrl:require('./img/ddjs.jpg')
                // },
                // {
                //     id:'5e804a2ce4b027314a1354e5',
                //     name:'卫生健康',
                //     srcUrl:require('./img/wsjk.jpg')
                // },
                // {
                //     id:'51f45bb5-a7e9-495c-af3c-b964b54de2d4',
                //     name:'脱贫攻坚',
                //     srcUrl:require('./img/tpgj.jpg')
                // },
                // {
                //     id:'3eda54d8-17d5-469d-aa28-26704fec7672',
                //     name:'环境保护',
                //     srcUrl:require('./img/hjbh.jpg')
                // },
                // {
                //     id:'5d68d4b8e4b0e2963a408857',
                //     name:'乡村振兴',
                //     srcUrl:require('./img/xczx.jpg')
                // },
                // {
                //     id:'b31fb2b6-ec1c-4c2d-898a-d3121c072d7a',
                //     name:'招商引资',
                //     srcUrl:require('./img/zsyz.jpg')
                // },
            ]
        }
    },
    created() {
        this.projectObtain()
    },
    methods: {
        outbreaklist(item) {
            // debugger
            // if(item.id == '5e3d40cfe4b0a6957ef82267' || item.id == '5e804a48e4b027314a1354e9' || item.id == 'b2f48823-a449-48e7-91ec-77d88924b0b3' || item.id == '5e804a2ce4b027314a1354e5'){
            //     let routeData = this.$router.resolve({ path: '/columnlists' , query: {  title: item.name , listId :item.id } });
            //     window.open(routeData.href, '_blank');
            //     Bus.$emit('jumpRouting', false );
            // }else{
            let routeData = this.$router.resolve({ path: '/contentList', query: { title: item.name, listId: item.uuid } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
            // } 
        },
        projectObtain() {
            const headers = {
                'Sign': generateSign()
            };
            let listcolumnparameter = {}
            listcolumnparameter.appInfoId = "10",
                listcolumnparameter.parentId = "148f7fde-4d1d-4f7f-9052-70fce8f62673"
            this.axios.post(getColumnByParentId, listcolumnparameter, { headers }).then(res => {
                this.columnList = res.data.data
            })
        },
    }
}
</script>
<style lang="">
    .column_cont{
        border-radius: 10px;
        -moz-box-shadow: 2px 2px 10px #d1cfcf;
        -webkit-box-shadow: 2px 2px 10px #d3cece;
        box-shadow:2px 2px 10px #d1cece;
        cursor:pointer; 
        margin:10px 16px;
        width:366px;
        text-align: center;
    }
    .column_cont img{
        width:366px;
        height:200px;
        border-radius: 10px;
        display:block;
    }
    .column_cont p{
        font-size: 16px;
        line-height:20px;
        color:#333333;
        padding-top: 16px;
        padding-bottom: 10px;
    }
    .column_cont:hover{
        border-radius: 10px;
        -moz-box-shadow: 2px 2px 10px #909090;
        -webkit-box-shadow: 2px 2px 10px #909090;
        box-shadow:2px 2px 10px #909090;
        font-weight: bolder;
    }
    .content_list_page{
        margin-top:20px;
        width:1200px;
        margin:0 auto;
        -moz-box-shadow:0 0 10px rgb(239, 239, 240);
        -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
        box-shadow:0 0 10px rgb(184, 184, 187);
        background:#ffffff;
    }
    .column_list{
        min-height:calc(100vh - 351px) !important;
        padding:20px 0 45px 0;
        display: flex;
        flex-wrap: wrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/columnList.vue